import { fetchRequest } from '@/services/http';
import { flow } from 'fp-ts/lib/function';
import { chain, mapLeft } from 'fp-ts/lib/TaskEither';
import { ApiError, parse, parseBlob, validate } from './response';

export const MAX_PER_PAGE = 1000;
export const FETCHING_AUTH_HEADER_ERROR = 0;
export const NETWORK_ERROR = 10;
export const PARSE_ERROR = 20;
export const DECODE_ERROR = 30;

const toApiError = (error: Error): ApiError => new ApiError(NETWORK_ERROR, error.message);

export const fetchUnparsedApi = flow(
  fetchRequest,
  mapLeft(toApiError),
);

export const fetchApi = flow(
  fetchRequest,
  mapLeft(toApiError),
  chain(parse),
  chain(validate),
);

export const fetchBlobApi = flow(
  fetchRequest,
  mapLeft(toApiError),
  chain(parseBlob),
  chain(validate),
);
